export default function (text) {
  if (text) {
    return text.replace(/<[^>]*>?/gm, "");
  }

  return "";
}
